import React from 'react';
import { motion } from 'framer-motion';

const GENRES = [
  { id: null, label: 'All' },
  { id: 28, label: 'Action' },
  { id: 35, label: 'Comedy' },
  { id: 18, label: 'Drama' },
  { id: 27, label: 'Horror' },
  { id: 878, label: 'Sci-Fi' },
  { id: 53, label: 'Thriller' },
  { id: 10749, label: 'Romance' },
  { id: 16, label: 'Animation' },
  { id: 80, label: 'Crime' },
  { id: 12, label: 'Adventure' },
];

const GenreFilter = ({ selected, onSelect }) => (
  <div className="flex gap-3 overflow-x-auto hide-scrollbar px-6 md:px-12 pb-2">
    {GENRES.map(g => {
      const active = selected === g.id;
      return (
        <motion.button
          key={g.id ?? 'all'}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onSelect(g.id)}
          className="flex-shrink-0 px-5 py-2 rounded-full text-sm font-body font-medium transition-all duration-200"
          style={{
            background: active ? 'var(--red)' : 'rgba(30,30,46,0.7)',
            color: active ? '#fff' : 'var(--muted)',
            border: active ? '1px solid rgba(229,9,20,0.5)' : '1px solid rgba(255,255,255,0.06)',
            boxShadow: active ? '0 0 20px rgba(229,9,20,0.3)' : 'none',
          }}
        >
          {g.label}
        </motion.button>
      );
    })}
  </div>
);

export default GenreFilter;
